<template lang="pug">
    v-flex(
        xs12
        v-if="activeTransaction.id != 6"
        )
        v-snackbar(
            v-model="errorSnackbar"
            :color="colors.danger"
        )
            v-icon error
            span Error: {{errorSnackMessage}}
        v-layout(row style="margin-top: 10px;")
            v-flex(xs6 md5)
                v-btn(block 
                    :dark="!submitButton.disabled"
                    :color="submitButton.color"
                    :disabled="submitButton.disabled"
                    @click="submitHandler()"
                    ref="submit"
                    )
                    span {{submitButton.text}}
            v-flex.hidden-sm-and-down
            v-flex(xs6 md5)
                v-btn#btn-abort(
                    block
                    :disabled="this.$route.path != '/'"
                    outline 
                    @click="clearAllData()"
                    :color="colors.primary"
                    ) 
                    span Anular
        CustomerSearch(
          v-model="showCustomerSearchModal"
          @customer:set="fetchCustomerData({field:'id', value: $event.id})"
          )
        salesperson-modal(
            v-model="showSalespersonModal"
            :color="activeTransaction.color"
            @submit="submitSalespersonCode($event)"
            showOptions
            :disabled="disabledSalesPersonModal"
            )
            div(slot="top-slot")
                v-form(ref="quotationForm")
                    v-layout(wrap v-if="activeTransaction.id === 3")
                        v-flex.xs12
                          v-select(
                            label="Vigencia"
                            v-model="expiration_date"
                            :items="quotationExpireOptions"
                            @input="checkQuotationDataState()"
                            item-value="days"
                            )
                        v-flex.xs12
                          v-text-field(
                            label="Email Cliente"
                            v-model="customer_email"
                            :rules="[mixRules.email, mixRules.required]"
                            @input="checkQuotationDataState()"
                            )
                        v-flex.xs12
                          v-text-field(
                            label="Comentario"
                            v-model="quotation_comment"
                            )
                              
                v-layout(wrap v-if="[1,2].includes(activeTransaction.id) && total > 2000")
                    v-flex.xs5.pt-4.pr-4.text-xs-center
                            span.subheading Venta normal
                    v-flex.xs2.pl-3
                            v-switch(
                                false-value="1"
                                true-value="3"
                                v-model="switchPhone"
                                :disabled="!!editingOrigin"
                            )
                    v-flex.xs5.pt-4.text-xs-center
                            span.subheading Venta telefónica
                    v-flex.xs5.pt-4.pr-4.text-xs-center
                            span.subheading Retiro en tienda
                    v-flex.xs2.pl-3
                            v-switch(
                                v-model="switchShipping"
                                @change="$nextTick(() => $refs.dispatchInput.focus())"
                            )
                    v-flex.xs5.pt-4.text-xs-center
                            span.subheading Despacho
                    v-flex.xs12(v-if="this.activeTransaction.id === 2")
                        v-textarea(
                            label="Comentario de Facturación"
                            outline
                            v-model="invoice_comment"
                            )
                    template(
                      v-if="(isCallCenter || switchShipping) && activeTransaction.id === 1"
                      )
                      v-flex.xs12.d-flex(
                        @click="showCustomerSearchModal = true"
                        style="cursor: pointer !important;"
                        )
                        v-text-field(
                          @keydown.stop="stopEvents"
                          outline
                          label="Cliente"
                          readonly
                          style="cursor: pointer !important;"
                          :value="customerData ? customerData.personName : ''"
                        )
                        v-btn.primary.ma-0(
                          style="height: 58px; width: 30px; max-width: 30px; min-width: 58px;"
                          depressed
                          )
                          v-icon.white--text search
                      v-flex.xs12(v-if="customerData.branch_offices")
                        v-autocomplete(
                          label="Sucursal"
                          @keydown.stop="stopEvents"
                          :items="customerData.branch_offices"
                          v-model="active_customer_branch_office"
                          item-text="address"
                          item-value="id"
                          outline
                          )
                      v-flex.xs12(v-if="customerData.g_core_business_sii")
                        v-autocomplete(
                          label="Giro"
                          @keydown.stop="stopEvents"
                          :items="customerData.g_core_business_sii"
                          v-model="active_core_business_id"
                          item-text="core_business"
                          item-value="id"
                          outline
                          )
                    template(
                      v-if="(isCallCenter || switchShipping) && activeTransaction.id === 2"
                      )
                      //v-flex.xs12
                        v-select(
                            :items="paymentTypes"
                            label="Forma de Pago"
                            @keydown.stop="stopEvents"
                            placeholder="Seleccione"
                            outline
                            v-model="selectedPayment"
                            item-value="id"
                            )
                      v-flex.xs12
                        v-text-field(
                            label="N° Órden de Compra"
                            @keydown.stop="stopEvents"
                            outline
                            v-model="ocNumber"
                            )

                    //- v-flex.xs12
                    //-     v-text-field(
                    //-         outline
                    //-         label="dirección de despacho"
                    //-         v-if="switchShipping"
                    //-         ref="dispatchInput"
                    //-         v-model="shippingAddress"
                    //-         )
            div(
                slot="content"
                v-if="!salespersonStatus && trySalesPersonCode"
                )
                span.red--text código de vendedor incorrecto
        auth-modal(
            v-model="showAuth"
            :color="activeTransaction.color"
            @submit="submitAuth($event)"
            @submit:clicked="handleSubmitClicked"
            )
            div(slot="content")
                v-layout(row wrap)
                    v-flex.xs12.red--text(v-if="!authStatus && trySupervisorCode") Código incorrecto
                    v-flex.xs12(v-if="authRequired() && authRequired().length > 0")
                        span.subheading Las siguientes operaciones requieren autorización:
                        ul
                            li(v-for="error in authRequired()") {{error}}
                    template(
                      v-if="assignedGroundSeller && assignedGroundSeller.hr_employee_id"
                      )
                      v-flex.xs5.pt-4.pr-4.text-xs-center
                              span.subheading En Sala
                      v-flex.xs2.pl-3
                              v-switch(
                                  v-model="commisionToGroundSeller"
                              )
                      v-flex.xs5.pt-4.text-xs-center
                              span.subheading En Terreno 
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import SaleService from '@/services/API/SaleService'
//import SaleVoucher from '@/printables/SaleVoucher'
//import QuotationVoucher from '@/printables/QuotationVoucher.js'
import AuthModal from '@/components/SimpleAuth/AuthModal'
import SalespersonModal from '@/components/SimpleAuth/SalespersonModal'
import SnackbarModalUtils from '@/mixins/SnackbarModalUtils.js'
import axios from 'axios'
import { splitDateTimeString } from '@/services/JSUtils'
import { rutFullFormat } from '../../../services/RUTFormatter'
import ProductHelper from '../../../services/API/helpers/ProductHelper'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import InputValidations from '../../../mixins/InputValidations'
import { cloneDeep, debounce } from 'lodash'
import CustomerSearch from '../../CustomerSearch/CustomerSearch.vue'
import printerApi from '../../../services/printerApi'

export default {
    name: 'confirmation-controls',
    props: {},
    data: function() {
        return {
            ocNumber: '',
            showCustomerSearchModal: false,
            active_core_business_id: null,
            active_customer_branch_office: null,
            quotationDataState: false,
            showSalespersonModal: false,
            salespersonStatus: false,
            trySalesPersonCode: false,
            salespersonCode: '',
            salespersonID: '',
            salesPersonName: '',
            showAuth: false,
            authStatus: false,
            supervisorCode: '',
            trySupervisorCode: false,
            supervisorID: '',
            errorSnackbar: false,
            errorSnackMessage: '',
            switchShipping: false,
            switchPhone: '1',
            quotationOptions: [
                { id: 4, text: 'Contra Entrega', days: 1 },
                { id: 5, text: '5 días', days: 5 },
                { id: 6, text: '7 días', days: 7 },
                { id: 7, text: '10 días', days: 10 },
                { id: 0, text: '15 días', days: 15 },
                { id: 1, text: '30 días', days: 30 },
            ],
            selectedPayment: 1,
            // shippingAddress: '',
            commisionToGroundSeller: false,
            expiration_date: 1,
            customer_email: '',
            quotation_comment: '',
            invoice_comment: '',
        }
    },
    computed: {
        quotationExpireOptions() {
            return this.quotationOptions.map(i => {
                if (i.id === 4) i.text = '1 día'
                return i
            })
        },
        ...mapState('CartModule', {
            items: 'items',
            total: 'total',
            globalDiscount: 'globalDiscount',
        }),
        paymentTypes() {
            return cloneDeep(this.pchPaymentConditions)
                .sort((a, b) => a.days - b.days)
                .filter(({ days }) =>
                    this.customerCreditOptions.some(o => o.days === days)
                )
                .map(({ id, type }) => ({
                    id,
                    text: type,
                }))
        },
        ...mapState('TransactionModule', {
            forcePrint: 'forcePrint',
            editMode: 'editMode',
            recoveredStorePickup: 'recoveredStorePickup',
            recoveredOcNumber: 'recoveredOcNumber',
            isEditingDispatchRequest: 'isEditingDispatchRequest',
            editedDispatchRequestNumber: 'editedDispatchRequestNumber',
            editingOrigin: 'editingOrigin',
        }),
        ...mapState('EmployeeModule', {
            validEmployee: 'validEmployee',
            employee: 'employee',
        }),
        ...mapState('CustomerModule', {
            customerDataStatus: 'dataStatus',
            customerData: 'customerData',
            createMode: 'createMode',
            customerID: 'customerID',
            availableDiscounts: 'availableDiscounts',
            activeOfficeID: 'activeOfficeID',
        }),
        ...mapState('SessionModule', [
            'companyData',
            'htmlPrint',
            'customerCreditOptions',
            'pchPaymentConditions',
        ]),
        ...mapGetters('CustomerModule', [
            'assignedGroundSeller',
            'activeCustomerEmail',
            'activeCustomerOffice',
            'pchPaymentCondition',
        ]),
        ...mapGetters('TransactionModule', {
            activeTransaction: 'activeTransaction',
        }),
        ...mapGetters('CartModule', {
            getIVA: 'getIVA',
            getNeto: 'getNeto',
        }),
        ...mapGetters('AuthModule', {
            branchOfficeID: 'branchOfficeID',
            isCallCenter: 'isCallCenter',
        }),
        submitButton: function() {
            if (this.items.length == 0) return this.noItemsInCartButton
            if (this.items.length > 20 && this.activeTransaction.id === 2)
                return this.maxInvoiceLinesButton
            if (this.total < 2000 && this.activeTransaction.id === 2) {
                return this.noMinAmountButton
            }
            let nostock = false
            this.items.forEach(item => {
                if (!item.stock || item.stock <= 0) nostock = true
            })
            if (nostock && this.activeTransaction.id !== 3)
                return this.noStockButton
            if (
                this.$route.path == '/cliente' &&
                this.customerDataStatus != this.activeTransaction.name
            )
                return this.incompleteCustomerDataButton
            // si es venta a personal y no hay cliente
            if (this.activeTransaction.id > 3) {
                if (this.validEmployee && this.$route.path == '/employee') {
                    return this.returnToSaleButton
                } else if (this.validEmployee && this.$route.path == '/') {
                    return this.confirmSaleButton
                } else {
                    return this.missingEmployee
                }
            }
            if (this.$route.path != '/') return this.returnToSaleButton
            if (this.items.length == 0) return this.noItemsInCartButton
            if (this.activeTransaction.name == 'quotation') {
                if (
                    ['invoice', 'quotation'].includes(this.customerDataStatus)
                ) {
                    return this.sendQuotationButton
                } else {
                    return this.missingCustomerDataButton
                }
            }
            if (this.activeTransaction.name == 'invoice') {
                if (this.customerDataStatus == 'invoice') {
                    return this.confirmSaleButton
                } else {
                    return this.missingCustomerDataButton
                }
            }
            if (this.activeTransaction.name == 'ticket') {
                return this.confirmSaleButton
            }
            if (this.activeTransaction.id > 3) return this.confirmSaleButton
        },
        returnToSaleButton: function() {
            return {
                disabled: false,
                text: 'Volver a Venta',
                handler: () => {
                    this.$router.replace({ path: '/' })
                },
                color: this.colors.info,
            }
        },
        noItemsInCartButton: function() {
            return {
                disabled: true,
                text: 'No se han agregado productos',
                color: this.colors.warning,
                handler: () => {},
            }
        },
        missingCustomerDataButton: function() {
            return {
                disabled: false,
                text: 'Debe agregar información del cliente',
                handler: () => {
                    this.$router.replace({ path: 'cliente' })
                },
                color: this.colors.danger,
            }
        },
        noStockButton: function() {
            return {
                disabled: false,
                text: 'Hay productos sin stock en la venta',
                handler: () => {},
                color: this.colors.danger,
            }
        },
        noMinAmountButton: function() {
            return {
                disabled: false,
                text: 'Facturas sólo $2.000',
                handler: () => {},
                color: this.colors.danger,
            }
        },
        incompleteCustomerDataButton: function() {
            return {
                disabled: false,
                text: 'Faltan campos por completar',
                handler: () => {},
                color: this.colors.danger,
            }
        },
        missingEmployee: function() {
            return {
                disabled: false,
                text: 'Debe ingresar un empleado válido',
                handler: () => {
                    this.$router.replace({ path: 'employee' })
                },
                color: this.colors.danger,
            }
        },
        sendQuotationButton: function() {
            return {
                disabled: false,
                text: '(F8) Enviar Cotización',
                handler: this.confirmSale,
                color: this.colors.success,
            }
        },
        confirmSaleButton: function() {
            return {
                disabled: false,
                text: '(F8) Confirmar Venta',
                handler: this.confirmSale,
                color: this.colors.success,
            }
        },
        maxInvoiceLinesButton() {
            return {
                disabled: false,
                text: 'Las facturas no pueden tener más de 20 líneas',
                handler: () => {},
                color: this.colors.danger,
            }
        },
        submitData: function() {
            let sale = {}
            sale.customer_id = this.customerID
            sale.default_branch_office = this.activeOfficeID
            sale.default_branch_office_id = this.activeOfficeID
            sale.default_branch_office_index =
                this.createMode && this.activeTransaction.id === 2 ? 0 : null
            if (this.activeTransaction.id === 2) {
                for (var prop in sale.customer) {
                    if (sale.customer.hasOwnProperty(prop)) {
                        if (!sale.customer[prop]) sale.customer[prop] = '-'
                    }
                }
            }
            if (this.activeTransaction.id === 3) {
                sale.customer_email = this.customer_email
                sale.expiration_date = this.quotationExpiration
                sale.quotation_comment = this.quotation_comment
            }
            if ([2, 3].includes(this.activeTransaction.id)) {
                if (
                    this.customerData &&
                    this.customerData.active_core_business_id
                )
                    sale.g_core_business_sii_id = this.customerData.active_core_business_id
            }
            // sale.sucursal_id = 1
            sale.pos_sale_type = this.activeTransaction.id
            sale.global_discount =
                this.globalDiscount.percentage_discount || null
            sale.description = this.description || 'vacío'
            sale.requester_employee_id = this.validEmployee && this.employee.id
            sale.employee_id = this.validEmployee && this.employee.id

            sale.seller_user_id = this.salespersonID
            sale.seller_user_code = this.salespersonCode
            if (
                this.commisionToGroundSeller &&
                this.assignedGroundSeller &&
                this.assignedGroundSeller.hr_employee_id &&
                this.assignedGroundSeller.hr_employee &&
                this.assignedGroundSeller.hr_employee.g_user &&
                this.assignedGroundSeller.hr_employee.g_user.auth_code
            ) {
                sale.seller_user_id = this.assignedGroundSeller.hr_employee_id
                sale.seller_user_code = this.assignedGroundSeller.hr_employee.g_user.auth_code
            }
            // sale.sucursal_id = 1
            sale.supervisor_user_id = this.supervisorID || null
            sale.supervisor_user_code = this.supervisorCode || null
            if (this.activeTransaction.id === 2) {
                sale.pos_origin_sale_id = this.switchPhone
                sale.flag_store_pickup = !this.switchShipping
            }
            if (this.isCallCenter) {
                this.pos_origin_sale_id = 3
                sale.flag_store_pickup = false
                if (!this.switchShipping)
                    sale.sale_comment =
                        'COMENTARIO DEL SISTEMA: RETIRO EN TIENDA'
            }
            if (this.globalDiscount.amount_discount) {
                sale.global_discount_amount = parseInt(
                    this.globalDiscount.amount_discount
                )
                /*
                let sum = 0
                this.items.forEach(item => (sum += item.subtotal))
                sale.global_discount =
                    (100 * this.globalDiscount.amount_discount) / sum
                */
            } else {
                sale.global_discount_amount = 0
            }
            if (!sale.global_discount) sale.global_discount = 0
            sale.total = Math.round(this.total)
            sale.sale_detail = this.items.map(item => {
                let price = () => {
                    if (item.replaced_price && item.replaced_price.replaced)
                        return item.sale_price
                    if ([2, 3].includes(this.activeTransaction.id))
                        return item.replaced_price
                            ? item.sale_price
                            : item.backend_invoice_price ||
                                  item.discounted_price ||
                                  item.sale_price
                    return item.replaced_price
                        ? item.sale_price
                        : item.discounted_price || item.sale_price
                }
                return {
                    product_id: item.id,
                    quantity: parseFloat(item.quantity),
                    // price: item.discounted_price || item.sale_price,
                    price: Math.round(price()),
                    discount:
                        item.lineDiscount &&
                        item.lineDiscount.percentage_discount
                            ? item.lineDiscount.percentage_discount
                            : 0, //Descuento por porcentaje
                    discount_unit_price:
                        item.lineDiscount &&
                        item.lineDiscount.unit_price_discount
                            ? item.lineDiscount.unit_price_discount
                            : 0,
                    wh_warehouse_id:
                        this.activeTransaction.id === 3
                            ? 1
                            : item.active_warehouse,
                }
            })
            //sale.global_discount_amount = 0
            if (this.editMode) {
                sale.sale_to_modify_id = this.editMode
            }
            if (this.switchShipping) {
                try {
                    sale.pos_customer_credit_option_id = this.customerCreditOptions.find(
                        o =>
                            o.days ===
                            this.pchPaymentConditions.find(
                                p => p.id === this.selectedPayment
                            ).days
                    ).id
                } catch (e) {
                    sale.pos_customer_credit_option_id === 'ERROR'
                }
                //sale.pos_customer_credit_option_id = this.selectedPayment
                sale.purchase_order = this.ocNumber || null
                if (this.activeTransaction.id === 1) {
                    sale.flag_store_pickup = !this.switchShipping
                    sale.customer_id = this.customerID
                    sale.g_core_business_sii_id = this.active_core_business_id
                    sale.default_branch_office = this.active_customer_branch_office
                    sale.default_branch_office_id = this.active_customer_branch_office
                }
            }
            if (this.isCallCenter) {
                this.flag_store_pickup = false
                try {
                    sale.pos_customer_credit_option_id = this.customerCreditOptions.find(
                        o =>
                            o.days ===
                            this.pchPaymentConditions.find(
                                p => p.id === this.selectedPayment
                            ).days
                    ).id
                } catch (e) {
                    sale.pos_customer_credit_option_id === 'ERROR'
                }
                if (
                    this.activeTransaction.id === 2 ||
                    this.activeTransaction.id === 3
                )
                    sale.purchase_order = this.ocNumber || null
                if (this.activeTransaction.id === 1) {
                    sale.customer_id = this.customerID
                    sale.g_core_business_sii_id = this.active_core_business_id
                    sale.default_branch_office = this.active_customer_branch_office
                    sale.default_branch_office_id = this.active_customer_branch_office
                }
            }
            if (this.switchShipping && this.pos_sale_type === 1)
                sale.pos_customer_credit_option_id = 4
            if (this.editingOrigin) sale.pos_origin_sale_id = this.editingOrigin
            sale.invoice_comment = this.invoice_comment
            return sale
        },
        hasLineDiscounts: function() {
            if (this.items.length === 0) return false
            return this.items.some(
                itm =>
                    itm.lineDiscount.percentage_discount ||
                    itm.lineDiscount.unit_price_discount ||
                    (itm.virtual_offer_price &&
                        parseInt(itm.virtual_offer_price.offer_price) ===
                            parseInt(itm.sale_price))
            )
        },
        quotationExpiration() {
            return this.getQuotationDays(this.expiration_date)
        },
        disabledSalesPersonModal() {
            if (this.activeTransaction.id === 3) return !this.quotationDataState
            if (
                this.activeTransaction.id === 1 &&
                (this.isCallCenter || this.switchShipping) &&
                this.total > 2000
            )
                return !(
                    this.customerData.id &&
                    this.active_core_business_id &&
                    this.active_customer_branch_office
                )
            return false
        },
    },
    methods: {
        ...mapActions('CustomerModule', ['fetchCustomerData']),
        ...mapActions('CartModule', {
            clearCart: 'resetState',
        }),
        ...mapActions('CustomerModule', {
            clearCustomer: 'resetState',
        }),
        ...mapActions('TransactionModule', {
            clearTransaction: 'resetState',
            toggleAuthMode: 'toggleAuthMode',
            setTransactionType: 'setTransactionType',
        }),
        ...mapActions('PromoModule', {
            clearPromos: 'resetState',
        }),
        ...mapActions('SpinnerModule', {
            showSpinner: 'showSpinner',
        }),
        ...mapActions('SnackbarModal', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        clearAllData: function() {
            this.clearCart()
            this.clearCustomer()
            this.clearTransaction()
            window.location.reload()
        },
        confirmSale: async function() {
            if (
                (this.activeTransaction.id === 2 ||
                    this.activeTransaction.id === 3) &&
                !this.submitData.g_core_business_sii_id
            ) {
                this.errorSnackMessage =
                    'Debe seleccionar un giro para el cliente'
                this.errorSnackbar = true
                return
            }
            if (
                (this.activeTransaction.id === 2 ||
                    this.activeTransaction.id === 3) &&
                (!this.submitData.default_branch_office ||
                    !this.submitData.default_branch_office_id)
            ) {
                this.errorSnackMessage =
                    'Debe seleccionar una sucursal para el cliente'
                this.errorSnackbar = true
                return
            }
            this.showSalespersonModal = true
        },
        getDetailType(item) {
            if (item.replaced_price && item.replaced_price.replaced)
                return 'replaced'
            if (
                item.virtual_offer_price &&
                parseInt(item.virtual_offer_price.offer_price) ===
                    parseInt(item.sale_price)
            )
                return 'offer'
            if (item.active_discount && item.active_discount.id)
                return 'wholesale'
            return ''
        },
        checkAuth: async function() {
            let verificador = this.authRequired()
            if (!verificador || verificador.length == 0) await this.submitSale()
            if (verificador && verificador.length > 0) {
                // this.toggleAuthMode(true)
                this.showAuth = true
            }
        },
        //TODO: Check auth for authroize employee sale
        submitAuth: function(code) {
            if (this.authStatus) return
            let route =
                process.env.VUE_APP_API_ROUTE +
                '/bar_authorization?auth_code=' +
                code +
                '&permission=authorize%20ticket%20sale'
            if (this.activeTransaction.id === 5)
                route =
                    process.env.VUE_APP_API_ROUTE +
                    '/bar_authorization?auth_code=' +
                    code +
                    '&permission=authorize%20generate%20employee_sale'
            axios
                .get(route)
                .then(response => {
                    if (response.data.is_authorized) {
                        this.submitSale(code)
                        this.supervisorCode = code
                        this.supervisorID = response.data.user.id
                        this.showAuth = false
                        this.authStatus = true
                    } else {
                        this.authStatus = false
                        this.trySupervisorCode = true
                    }
                })
                .catch(e => {
                    this.authStatus = false
                    this.trySupervisorCode = true
                })
        },
        resetAuth() {
            this.showSalespersonModal = false
            this.salespersonStatus = false
            this.trySalesPersonCode = false
            this.salespersonCode = ''
            this.salespersonID = ''
            this.salesPersonName = ''
            this.showAuth = false
            this.authStatus = false
            this.supervisorCode = ''
            this.trySupervisorCode = false
            this.supervisorID = ''
        },
        submitSalespersonCode: function(code) {
            // FIXME: Remove heading 0s when in production
            if (this.salespersonStatus) return
            code = this.prependZeros(code, 3)
            // if (code === '000') {
            //     this.salespersonStatus = false
            //     this.trySalesPersonCode = true
            //     return
            // }
            let route =
                process.env.VUE_APP_API_ROUTE +
                '/authorization?auth_code=' +
                code +
                '&permission=access_to%20point_sale'
            axios
                .get(route)
                .then(response => {
                    if (response.data.is_authorized) {
                        this.salespersonCode = code
                        this.salespersonID = response.data.user.id
                        this.salesPersonName =
                            response.data.user.names +
                            ' ' +
                            response.data.user.last_name1
                        this.checkAuth()
                        this.showSalespersonModal = false
                        this.salespersonStatus = true
                    } else {
                        this.salespersonStatus = false
                        this.trySalesPersonCode = true
                    }
                })
                .catch(error => {
                    this.salespersonStatus = false
                    this.trySalesPersonCode = true
                })
        },
        prependZeros: function(string, length) {
            let count = length - string.length
            let prepend = ''
            if (count > 0) {
                for (let i = 0; i < count; i++) {
                    prepend += '0'
                }
            }
            return prepend + '' + string
        },
        formatBarCode: function(barcode) {
            let code = '' + barcode
            let prefix = 'SC'
            let tail = code
            if (code.length > 2) {
                let pf = code.slice(0, 2)
                if (isNaN(pf)) {
                    prefix = pf
                    tail = code.slice(2, code.length)
                }
            }
            tail = this.prependZeros(tail, 12)
            return prefix + tail
        },
        setReprintData: function(sale) {
            const fullName = e => `${e.names} ${e.last_name1}`
            this.salesPersonName = fullName(sale.g_seller_user.hr_employee)
            if (sale.sl_customer) {
            }
        },
        reprintSaleTicket: async function(
            barcode = null,
            dateTime = null,
            quotationMode = false
        ) {
            let formattedCode = this.formatBarCode(barcode)
            let res = await this.printSaleTicket(
                formattedCode,
                dateTime,
                quotationMode
            )
            return res
        },
        printSaleTicket: async function(
            barcode = '123456789123',
            dateTime = null,
            quotationMode = false,
            editMode = false,
            dispatchRequestId = null
        ) {
            //if (this.isEditingDispatchRequest) return true
            if (this.isEditingDispatchRequest)
                dispatchRequestId = this.editedDispatchRequestNumber
            let obj = {}
            obj.quotationExpiration = this.quotationExpiration
                ? this.quotationExpiration
                : /*
                      .split('-')
                      .reverse()
                      .join('/')
                      */
                  null
            obj.isQuotation = quotationMode
            obj.editMode = editMode
            obj.quotation = quotationMode
            obj.hasLineDiscounts = this.hasLineDiscounts
            obj.title = this.companyData.business_name
            obj.RUT = this.companyData.rut
            obj.activities = this.companyData.commercial_business
            obj.address = this.companyData.address
            //obj.phone = '+56512 123456'
            obj.seller = this.salesPersonName || ''
            obj.cRUT = this.customerData.rut
                ? rutFullFormat(this.customerData.rut)
                : ''
            obj.cactivities = this.getNameActivityBusiness() || ''
            obj.caddress = this.activeCustomerOffice
                ? this.activeCustomerOffice.address || ''
                : ''
            obj.cpersonName = this.customerData.personName || ''
            obj.cbusinessName = this.customerData.businessName || ''
            obj.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT
            obj.cmail = this.activeCustomerEmail || ''
            obj.cphone = this.customerData.phone || ''
            obj.cCity = this.activeCustomerOffice
                ? this.activeCustomerOffice.city || ''
                : ''
            obj.cCommune =
                this.activeCustomerOffice && this.activeCustomerOffice.g_commune
                    ? this.activeCustomerOffice.g_commune.name || ''
                    : ''
            obj.cZone = this.activeCustomerOffice
                ? this.activeCustomerOffice.zone || ''
                : ''
            obj.barcode = barcode
            //win.window.items = this.items
            obj.items = this.transformOfferToDiscount()
            obj.items = obj.items.map(itm => {
                if (itm.neto) {
                    itm.neto = ProductHelper.truncateAndRound(itm.neto)
                }
                return itm
            })
            obj.total = this.total
            obj.globalDiscount = this.globalDiscount
            obj.dateTime = { date: null, time: null }
            obj.typeCode =
                this.isCallCenter && this.activeTransaction.id !== 3
                    ? 10
                    : this.activeTransaction.id
            if (dateTime) obj.dateTime = splitDateTimeString(dateTime)

            if (dispatchRequestId && this.activeTransaction.id !== 3)
                obj.subtitle = `SOLICITUD DE DESPACHO N°${dispatchRequestId} ${
                    this.isEditingDispatchRequest ? '(EDITADA)' : ''
                }`
            else if (this.activeTransaction.id <= 2)
                obj.subtitle = 'TICKET DE VENTA'
            obj.saleType = 'BOLETA'
            if (this.activeTransaction.id === 2) obj.saleType = 'FACTURA'
            if (this.activeTransaction.id === 4)
                obj.subtitle = 'CONSUMO INTERNO'
            if (this.activeTransaction.id === 5)
                obj.subtitle = 'TICKET DE VENTA A PERSONAL'
            if (this.activeTransaction.id === 3)
                obj.subtitle = `COTIZACIÓN N°${barcode}`
            if (this.activeTransaction.id === 6)
                obj.subtitle = `TICKET DE CAMBIO N°${barcode}`
            if (this.activeTransaction.id > 1) {
                obj.iva = this.getIVA
                obj.neto = this.getNeto
            }
            if ([4, 5].includes(this.activeTransaction.id))
                obj.requester_employee = this.employee
                    ? this.employee.name_case || ''
                    : ''
            if (this.htmlPrint) {
                let win = window.open('boleta2.html', '_blank')
                Object.assign(win.window, obj)
                return true
            } else if (this.activeTransaction.id === 6) {
                let win = window.open('boleta2.html', '_blank')
                Object.assign(win.window, obj)
                return true
            } else {
                // console.log(printerApi.formatPayload(obj))
                // return
                let timeout = () =>
                    new Promise((resolve, reject) => {
                        setTimeout(
                            () => reject('Tiempo de espera agotado'),
                            process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT
                                ? parseInt(
                                      process.env
                                          .VUE_APP_PRINTER_SERVICE_TIMEOUT
                                  )
                                : 8000
                        )
                    })
                let promise = Promise.race([printerApi.print(obj), timeout()])
                let comp = null
                try {
                    let comp = await promise
                    return comp
                } catch (e) {
                    try {
                        let win = window.open('boleta2.html', '_blank')
                        Object.assign(win.window, obj)
                        return true
                    } catch (e) {
                        return false
                    }
                }
            }
        },
        transformOfferToDiscount() {
            let cart = cloneDeep(this.items)
            cart = cart.map(item => {
                if (item.replaced_price && item.replaced_price.replaced)
                    return item
                if (
                    item.virtual_offer_price &&
                    parseInt(item.sale_price) ===
                        parseInt(item.virtual_offer_price.offer_price) &&
                    (!item.lineDiscount ||
                        (!item.lineDiscount.percentage_discount &&
                            !item.lineDiscount.unit_price_discount))
                ) {
                    item.lineDiscount.unit_price_discount =
                        (parseInt(item.virtual_offer_price.sale_price) -
                            parseInt(item.virtual_offer_price.offer_price)) *
                        parseFloat(item.quantity)
                    item.lineDiscount.unit_price_discount = Math.round(
                        item.lineDiscount.unit_price_discount
                    )
                    item.sale_price = parseInt(
                        item.virtual_offer_price.sale_price
                    )
                    item.detail_type = 'offer'
                }
                return item
            })
            return cart
        },
        transformCartToDetail(items = this.items) {
            return items.map(item => {
                let price = () => {
                    if (item.replaced_price && item.replaced_price.replaced)
                        return item.sale_price
                    if ([2, 3].includes(this.activeTransaction.id))
                        return (
                            item.backend_invoice_price ||
                            item.discounted_price ||
                            item.sale_price
                        )
                    return item.discounted_price || item.sale_price
                }
                return {
                    product_id: item.id,
                    quantity: parseFloat(item.quantity),
                    // price: item.discounted_price || item.sale_price,
                    price: Math.round(price()),
                    discount:
                        item.lineDiscount &&
                        item.lineDiscount.percentage_discount
                            ? item.lineDiscount.percentage_discount
                            : 0, //Descuento por porcentaje
                    discount_unit_price:
                        item.lineDiscount &&
                        item.lineDiscount.unit_price_discount
                            ? item.lineDiscount.unit_price_discount
                            : 0,
                    wh_warehouse_id:
                        this.activeTransaction.id === 3
                            ? 1
                            : item.active_warehouse,
                    detail_type: item.detail_type || this.getDetailType(item),
                }
            })
        },
        submitSale: debounce(async function(code = null) {
            this.showSpinner('orange')
            let transType = this.submitData.pos_sale_type
            if (code) this.submitData.supervisor_user_code = code
            let response = {}
            let data = cloneDeep(this.submitData)
            data.sale_detail = this.transformCartToDetail(
                this.transformOfferToDiscount()
            )

            // this.printSaleTicket(
            //     'SE000013231312',
            //     null,
            //     transType === 3,
            //     this.editMode,
            //     null
            // )
            // return

            try {
                response = await SaleService.store(
                    //this.submitData,
                    data,
                    this.editMode
                )
            } catch (e) {
                this.salespersonStatus = false
                this.authStatus = false
                this.errorSnackbar = true
                this.errorSnackMessage =
                    'Ha ocurrido un error de conexión o el vendedor no pertence a esta sucursal'
                this.showSpinner(false)
                this.salesPersonName = ''
                this.salesPersonCode = ''
                this.salespersonID = ''

                this.supervisorCode = ''
                this.supervisorID = ''
                return
            }
            if (
                [200, 201, 'success'].includes(
                    response.status
                ) /* response.data.http_status_code === 201 */
            ) {
                let dateTime = response.data.created_at.date
                let barcode =
                    response.data.sale_id_formatted ||
                    response.data.internal_consumption_id_formatted ||
                    response.data.employee_sale_id_formatted ||
                    response.data.quotation_id_formatted
                let stat = await this.printSaleTicket(
                    barcode,
                    dateTime,
                    transType === 3,
                    this.editMode,
                    this.isCallCenter
                        ? response.data.wh_dispatch_request_id || null
                        : null
                )
                if (!this.isCallCenter) {
                    try {
                        stat = await this.printSaleTicket(
                            barcode,
                            dateTime,
                            transType === 3,
                            this.editMode,
                            this.isCallCenter
                                ? response.data.wh_dispatch_request_id || null
                                : null
                        )
                        this.showSpinner(false)
                        this.clearAllData()
                    } catch (e) {
                        this.showSpinner(false)
                        this.clearAllData()
                    }
                } else {
                    this.showSpinner(false)
                    this.clearAllData()
                }
            } else {
                this.salespersonStatus = false
                this.authStatus = false
                this.errorSnackbar = true
                this.errorSnackMessage = 'Error en el servidor'
                if (response.data || response.data.error)
                    this.errorSnackMessage = response.data.error
                this.showSpinner(false)
            }
        }, 1000),
        reprint: async function() {
            if (!this.forcePrint.barcode) return
            this.setReprintData(this.forcePrint.sale)
            let stat = await this.reprintSaleTicket(
                this.forcePrint.barcode,
                this.forcePrint.dateTime,
                false
            )
            if (stat) this.clearAllData()
        },
        authRequired: function() {
            let auth = []
            this.items
                .filter(
                    item => item.replaced_price && item.replaced_price.replaced
                )
                .forEach(item => {
                    auth.push(
                        'Reemplazo de precio: ' +
                            item.name +
                            ' - Original: $' +
                            this.mixCurrencyFormatter(
                                item.replaced_price.original
                            ) +
                            ' Actual: $' +
                            item.sale_price
                    )
                })
            //if (!this.activeTransaction.id === 3)
            /*
            this.items
                .filter(
                    item =>
                        !item.stocks
                            .find(
                                s =>
                                    parseInt(s.g_branch_office_id) ===
                                    parseInt(this.branchOfficeID)
                            )
                            .wh_warehouses.map(r => r.wh_warehouse_id)
                            .includes(item.active_warehouse)
                )
                .forEach(product => {
                    auth.push(
                        'Cambio de bodega: ' +
                            product.name +
                            ' - Original: ' +
                            product.default_warehouse +
                            ' Actual: ' +
                            product.active_warehouse
                    )
                })
                */
            if (this.activeTransaction.id !== 3) {
                this.items.forEach(i => {
                    let office = null
                    let activeWarehouse = i.stocks.reduce((aw, stock) => {
                        if (!aw) {
                            aw = stock.wh_warehouses.find(
                                wh => wh.wh_warehouse_id === i.active_warehouse
                            )
                            if (aw) office = stock.g_branch_office_id
                        }
                        return aw
                    }, null)
                    if (
                        activeWarehouse.wh_warehouse_type_id !== 5 ||
                        office !== this.branchOfficeID
                    ) {
                        auth.push(
                            'Bodega seleccionada requiere autorización: ' +
                                `Bodega - ${
                                    activeWarehouse.wh_warehouse_name
                                } | procuto - ${i.name}`
                        )
                    }
                })
            }
            this.items.filter(item => item.stock <= 0).forEach(product => {
                auth.push('Producto sin stock: ' + product.name)
            })
            this.items
                .filter(
                    item =>
                        item.lineDiscount.unit_price_discount ||
                        item.lineDiscount.percentage_discount
                )
                .forEach(product => {
                    if (
                        product.lineDiscount.unit_price_discount &&
                        typeof product.lineDiscount.unit_price_discount ===
                            'string'
                    )
                        product.lineDiscount.unit_price_discount = parseInt(
                            product.lineDiscount.unit_price_discount
                        )
                    auth.push(
                        'Descuento manual: Se ha aplicado un descuento de ' +
                            (product.lineDiscount.unit_price_discount
                                ? '$' +
                                  this.mixCurrencyFormatter(
                                      product.lineDiscount.unit_price_discount
                                  )
                                : product.lineDiscount.percentage_discount +
                                  '%') +
                            ' a ' +
                            product.name
                    )
                })
            const addGDCValidation = () => {
                auth.push(
                    'Se ha aplicado un descuento de ' +
                        this.globalDiscount.percentage_discount +
                        '% al total de la boleta'
                )
            }
            if (
                this.activeTransaction.id === 5 &&
                this.globalDiscount.percentage_discount &&
                this.globalDiscount.percentage_discount !==
                    this.employee.discount
            ) {
                addGDCValidation()
            } else if (
                this.activeTransaction.id !== 5 &&
                this.globalDiscount.percentage_discount &&
                !this.availableDiscounts.includes(
                    this.globalDiscount.percentage_discount
                )
            ) {
                addGDCValidation()
            }

            if (this.globalDiscount.amount_discount)
                auth.push(
                    'Se ha aplicado un descuento de $' +
                        this.mixCurrencyFormatter(
                            this.globalDiscount.amount_discount
                        ) +
                        ' al total de la boleta'
                )
            if (this.activeTransaction.id > 3)
                auth.push(
                    this.activeTransaction.displayName +
                        ' requiere autorización.'
                )
            if (
                this.assignedGroundSeller &&
                this.assignedGroundSeller.hr_employee_id
            )
                auth.push(
                    'Este cliente tiene un vendedor en terreno asociado' +
                        ' para la sucursal seleccionada. ' +
                        'La venta debe ser asignada y autorizada.'
                )
            if (this.editMode && this.isEditingDispatchRequest)
                auth.push(
                    'Edición de Solicitud de Despacho requiere autorización'
                )
            if (auth.length == 0) auth = null
            return auth
        },
        checkQuotationDataState() {
            if (!this.$refs.quotationForm.validate())
                return (this.quotationDataState = false)
            this.quotationDataState =
                this.customer_email && this.expiration_date
        },
        getQuotationDays(days) {
            let date = new Date()
            date.setDate(date.getDate() + days)
            let dd = date.getDate()
            if (('' + dd).length === 1) dd = '0' + dd
            let mm = date.getMonth() + 1
            if (('' + mm).length === 1) mm = '0' + mm
            let yyyy = date.getFullYear()
            return `${yyyy}-${mm}-${dd}`
        },
        /*
         */
        getNameActivityBusiness() {
            if (this.customerData && this.customerData.id) {
                let result = this.customerData.g_core_business_sii.find(
                    giro =>
                        giro.id === this.customerData.active_core_business_id
                )
                return result.core_business
            }
            return null
        },
        handleSubmitClicked() {
            if (!this.commisionToGroundSeller) return
            let auth = this.authRequired()
            if (
                auth.length &&
                auth.length === 1 &&
                auth[0] ===
                    'Este cliente tiene un vendedor en terreno asociado' +
                        ' para la sucursal seleccionada. ' +
                        'La venta debe ser asignada y autorizada.'
            )
                this.submitSale(null)
        },
        stopEvents(e) {
            e.stopPropagation()
        },
        submitHandler() {
            /*
             */
            this.submitButton.handler()
        },
    },
    watch: {
        forcePrint: function() {
            this.reprint()
        },
        showAuth: function(val) {
            if (this.authStatus) return
            if (!val) {
                this.resetAuth()
            }
        },
        isCallCenter: {
            immediate: true,
            handler(v) {
                if (v) {
                    this.switchPhone = '3'
                    this.switchShipping = true
                    this.setTransactionType(2)
                }
            },
        },
        activeCustomerEmail(v) {
            this.customer_email = v
        },
        showSalespersonModal(v) {
            this.toggleAuthMode(v)
            if (v) {
                this.checkQuotationDataState()
            }
        },
        customerData(v) {
            if (v.main_g_core_business_sii_id)
                this.active_core_business_id = v.main_g_core_business_sii_id
            if (v.branch_offices) {
                let office = v.branch_offices.find(o => o.default_branch_office)
                this.active_customer_branch_office = office.id
            }
        },
        recoveredStorePickup(v) {
            if (v) this.switchShipping = true
        },
        pchPaymentCondition: {
            immediate: true,
            handler(v) {
                console.log('asdfsadsd', v)
                if (v || v === 0) this.selectedPayment = v
            },
        },
    },
    components: {
        'auth-modal': AuthModal,
        'salesperson-modal': SalespersonModal,
        CustomerSearch,
    },
    mixins: [SnackbarModalUtils, CurrencyUtils, InputValidations],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    /*
    mounted: function() {
    },
    */
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>
